import { Entry } from "interfaces/entry";
import { POOL_STATUS } from "utils/constants";
import { ContestantResponse } from "interfaces/contestant-response";
import { ContestantId } from "interfaces/contestant-result-places";
import SingleSelectionSettledEntryItem
  from "components/pool-details/entries/single-selection-entry-list/single-selection-settled-entry-item";
import SingleSelectionOpenEntryItem
  from "components/pool-details/entries/single-selection-entry-list/single-selection-open-entry-item";
import { ContestEntryState } from "utils/contest-utils";

interface Props {
  entries: Entry[];
  contestants: ContestantResponse[];
  selectBet: any;
  winningContestantIds: ContestantId[];
  poolStatus: number;
  selectedEntry: Entry | undefined;
  contestEntryState?: ContestEntryState;
  contestEntryId?: string;
}

const getItem = (poolStatus: number) => {
  switch (poolStatus) {
    case POOL_STATUS.PENDING:
      return SingleSelectionSettledEntryItem;
    case POOL_STATUS.OPEN:
      return SingleSelectionOpenEntryItem;
    case POOL_STATUS.LIVE:
      return SingleSelectionSettledEntryItem;
    case POOL_STATUS.SETTLED:
      return SingleSelectionSettledEntryItem;
    default:
      return SingleSelectionSettledEntryItem;
  }
};

const moveWinnerEntryToTheTop = (entries: Entry[], winningEntryIds: string[]) => {
  entries.forEach((entry: Entry, index: number) => {
    if (winningEntryIds.includes(entry.contestant_id)) {
      entries.splice(index, 1);
      entries.unshift(entry);
    }
  });
  return entries;
};

const SingleSelectionEntryList = ({
                                    entries,
                                    contestants,
                                    selectBet,
                                    winningContestantIds,
                                    poolStatus,
                                    selectedEntry,
                                    contestEntryId
                                  }: Props) => {
  const totalSeedDistribution = contestants.reduce((acc, item) => {
    return acc + item.seed_distribution;
  }, 0);

  const Item = getItem(poolStatus);

  const sortedEntries = winningContestantIds
    ? moveWinnerEntryToTheTop(entries, winningContestantIds)
    : entries;

  return (
    <>
      {sortedEntries.map((entry: Entry) => {
        const projectedWin =
          entry.seed_distribution / totalSeedDistribution || 0;
        const isSelected =
          !!selectedEntry &&
          entry.pool_entry_id === selectedEntry.pool_entry_id;

        return (
          <Item
            key={entry.pool_entry_id}
            selectBet={selectBet}
            item={entry}
            winner={winningContestantIds.includes(entry.contestant_id)}
            isSelected={isSelected}
            projectedWin={projectedWin}
            contestEntryId={contestEntryId}
          />
        );
      })}
    </>
  );
};

export default SingleSelectionEntryList;
